<template>
  <div>
    <button @click="fetchProductById(ID)" class="submit-button" type="button">
      Continue
    </button>

    <!-- use the mod
    al component, pass in the prop -->
    <TestModal
      v-if="showModal"
      :titleProduct="title"
      :desc="productDescription"
      :amt="amount"
      :productDetails="productsDetails"
      @close="close"
      @proceed="proceedToTerms"
      @goToKyc="goToKyc"
    ></TestModal>
    <Agreement v-if="showTerms" @close="closeTerms"></Agreement>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";
import ModalComponent from "./Onboarding/ModalComponent";
import TestModal from "./Onboarding/TestModal2";
import Agreement from "./Onboarding/Agreement";

export default {
  name: "ButtonOnboardingPackage",
  components: {
    ModalComponent,
    TestModal,
    Agreement
  },
  props: {
    title: null,
    ID: null,
    productDescription: null,
    packages: null,
    amount: null,
    monthlyAmount: null,
    tenure: null,
    isActive: false
  },
  computed: {},
  data() {
    return {
      modalActive: false,
      showDropdown: false,
      showModal: false,
      showTerms: false,
      productInfos: {},
      products: [
        {
          ID: null,
          name: null,
          productDescription: null,
          amountOS: null,
          monthlyAmountLO: null,
          tenure: null
        }
      ],
      productsDetails: []
    };
  },
  methods: {
    setActive() {
      this.modalActive = true;
    },
    modalActiveClose() {
      this.modalActive = false;
      console.log(this.modalActive);
      console.log("close it wiht right button");
    },

    close() {
      this.showModal = false;
      this.showTerms = false;
    },

    proceedToTerms() {
      this.showTerms = true;
    },
    showModalFunc() {
      this.showModal = true;
    },
    closeTerms() {
      this.showTerms = false;
      this.showModal = false;
      this.$emit("nextPage");
    },
    goToKyc() {
      this.$emit("nextPageKyc");
    },
    async fetchBanks() {
      const HTTP = this.$httpUtils.instance;
      let res = await HTTP.get("/arnergyProducts");

      // parse for "arnergy-select" use
      return res.data
        .map(item => {
          console.log(res.data);
          return {
            id: item.id,
            name: item.productType,
            productDescription: item.productDescription,
            amountOS: item.amountOS,
            monthlyAmountLO: item.monthlyAmountLO,
            tenure: item.tenureLO
          };
        })
        .sort((a, b) => {
          return a.name > b.name ? 1 : -1;
        });
    },
    async fetchProductById(id) {
      await this.updateStateFunc();
      localStorage.productName = this.title;
      const data = {
        productId: id.toString()
      };
      const HTTP = this.$httpUtils.instance;
      let res = await HTTP.post("/arnergyProductDetails/getProductById", data);

      if (res.data) {
        this.showModal = true;

        // parse for "arnergy-select" use
        this.productsDetails = res.data
          .map(item => {
            console.log(res.data);
            return {
              id: item.id,
              productId: item.productid,
              contractTenure: item.contracttenure,
              cautionFee: item.cautionfee,
              monthlyPayment: item.monthlypayment
            };
          })
          .sort((a, b) => {
            return a.id > b.id ? 1 : -1;
          });
      }
    },
    updateStateFunc() {
      const HTTP = this.$httpUtils.instance;
      HTTP.patch("/onboardingStates", {
        customerid: localStorage.customerId,
        stateid: 0,
        packageType: "LO",
        id: localStorage.customerState
      }).then(res => {
        this.$store.commit("saveOnboanrdingState", 0);

        if (res.data) null;
      });
    }
  },
  async mounted() {
    let obj = this.packages.find(x => x.id == this.ID);
    const productInfos = {
      name: obj.name,
      id: obj.id
    };
    this.productInfos = productInfos;
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/_reduced_variables.scss";

.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin: 0 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/ButtonOnboardingPackage.vue